import {
  setCookieForAllSubdomains,
  deleteCookieForAllSubdomains,
} from './cookie';
import { isIVFrameSupported } from './iv-frame';

const _isEditorOverrideToClassic = () => {
  return localStorage.getItem('editorOverride') === 'classic';
};

export const getEditorHost = () => {
  if (!_isEditorOverrideToClassic() && isIVFrameSupported()) {
    return window.location.origin;
  }
  return process.env.CLASSIC_EDITOR_HOST;
};

export const updateEditorAuthCookie = () => {
  const cookieName = process.env.EDITOR_AUTH_COOKIE;
  const cookieValue = localStorage.getItem('authToken');

  if (!cookieValue) {
    deleteCookieForAllSubdomains(cookieName);
    return;
  }

  setCookieForAllSubdomains(cookieName, cookieValue);
};
